<template>
    <tr :id="item.id" :key="item.id" :class="{'mark-as-important': item.priority == 1}">
        <td scope="row">
            <div class="form-check">
                <input class="form-check-input" type="checkbox" name="selectedQuotesForDelete" v-model="selectedQuoteForDelete" :value="item.id">
            </div>
        </td>
        <td>
            <router-link :to="{ name: 'viewQuote', params: { id: item.id }}" class="edit-btn">#{{ item.quotation_number }}</router-link>
        </td>
        <td :title="item.quote_date">{{ formatDate(item.quote_date) }}</td>
        <td><template v-if="item.customer_data">{{item.customer_data.company_name}}</template> <template v-if="item.contact_name!=''"> , ({{item.contact_name}}) </template></td>
        <td class="product_text"><span class="prod-wrap">{{item.item_name}}</span></td>

        <td>
            <span class="lt-bl-bg" :class="getQuotationStatusCssClass(item)" v-if="item.status_details">{{item.status_details.name}}</span>

            <span v-if="item.id != item.parent_quote" class="lt-bl-bgs blue">clone</span>

        </td>

        <td class="add_column hide" v-if="user_type == 1 || role == 'Admin'">
            <template v-if="item.added_data">{{item.added_data.name}}</template>
        </td>
        <td v-if="is_draft != 1">
            <span class="thumbsup"><a v-if="user_type == 1 && item.status == 3" href="javascript:void(0);" @click="approveQuotations" class="approve_btn" title="Approve Price" :data-id="item.id"><i class="ri-thumb-up-fill me-1"></i></a></span>
            <a v-if="can_delete_quotation" href="javascript:void(0);" v-on:click="removeItem(item.id)" class="del_btn" title="Delete Quote" :data-id="item.id"><i class="ri-delete-bin-6-line"></i></a>

        </td>
    </tr>
</template>

<script>
import Vue from "vue";

export default {
    name: "QuotationListItem",
    props: ['item', 'bus', 'user_type', 'role', 'can_delete_quotation', 'is_draft'],
    mounted() {
        this.bus.$on('checkQuotesForDelete', (event) => {
            this.selectedQuoteForDelete = event;
        });
    },
    data(){
        return {
            selectedQuoteForDelete: false
        }
    },
    methods: {
        removeItem(id){
            Vue.$confirm({
                title: 'Are you sure?',
                message: 'Are you sure you want to delete quote?',
                button: {
                    yes: 'Yes',
                    no: 'Cancel'
                },
                callback: confirm => {
                    if(confirm) {
                        this.$emit('deleteItem', {id: id});
                    }

                }
            })
        },
        approveQuotations(){
            this.$emit('onApproveQuotations', this.item.id);
        },
        getQuotationStatusCssClass(item) {
            let cssClass = '';
            if(item.status=='2') {
                cssClass = 'lght-peach';
            } else if(item.status=='3') {
                cssClass ='lght-pink';
            } else if(item.status=='4') {
                cssClass ='lght-green';
            } else if(item.status=='5') {
                cssClass ='lght-grn';
            } else {
                cssClass ='lght-blue';
            }
            return cssClass;
        }
    },
    watch: {
        selectedQuoteForDelete: {
            handler: function(value) {
                this.$emit('changeSelectedQuoteForDelete', {checked: value, id: this.item.id});
            }
        }
    },
}
</script>

<style scoped>

</style>
